export default {
  getRecommendRecipes() {
    return this.http('ExerciseCheck', 'get', '/api/v1/recipes/list').then(
      res => {
        return res;
      }
    );
  },
  getRecommendSports() {
    return this.http('ExerciseCheck', 'get', '/api/v1/exercises/list').then(
      res => {
        return res;
      }
    );
  }
};
